(() => {
  const FORM_SELECTOR = '#easylockdown-password-form';
  const LAYOUT_SELECTOR = '[data-easylockdown-password-layout]';
  const NATIVE_FORM_SELECTOR = '.password-form';
  const ACTIVE_CLASS = 'easylockdown-password-layout-active';

  let appForm;
  let layout;
  let stylesheet;
  let formObserver;
  let formAdapted = false;

  const formIsRequested = () => {
    if (!appForm || !appForm.isConnected || appForm.hidden) return false;
    return appForm.style.display !== 'none';
  };

  const setActive = (active) => {
    if (!layout) return;
    layout.hidden = !active;
    document.body.classList.toggle(ACTIVE_CLASS, active);
    document.body.classList.toggle('password', active);
    if (stylesheet) stylesheet.media = active ? 'all' : 'not all';
    if (!active) {
      const modal = layout.querySelector('.password-modal');
      if (modal) modal.open = false;
    }
  };

  const sync = () => {
    const requested = formIsRequested();
    if (requested && !formAdapted) adaptPasswordForm();
    setActive(requested && formAdapted);
  };

  const watchPasswordForm = () => {
    const candidate = document.querySelector(FORM_SELECTOR);
    if (!candidate) return false;

    appForm = candidate;
    stylesheet = document.querySelector('[data-easylockdown-password-stylesheet]');
    formObserver?.disconnect();
    formObserver = new MutationObserver(sync);
    formObserver.observe(appForm, {
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden'],
    });
    sync();
    return true;
  };

  const adaptPasswordForm = () => {
    layout = document.querySelector(LAYOUT_SELECTOR);
    const nativeForm = layout?.querySelector(NATIVE_FORM_SELECTOR);

    if (!layout || !appForm || !nativeForm) return false;
    if (!formIsRequested()) return false;
    if (appForm.contains(nativeForm)) return true;

    const appInput = appForm.querySelector('#easylockdown-password');
    const appButton = appForm.querySelector('#easylockdown-password-form-button');
    const appError = appForm.querySelector('#easylockdown-password-error');
    const appNote = appForm.querySelector('#easylockdown-password-note');
    const nativeInput = nativeForm.querySelector('#Password');
    const nativeButton = nativeForm.querySelector('.password-button');
    const field = nativeForm.querySelector('.password-field');
    const label = nativeForm.querySelector('.field__label');

    if (!appInput || !appButton || !nativeInput || !nativeButton || !field) return false;

    appInput.className = nativeInput.className;
    appInput.setAttribute('autocomplete', 'current-password');
    appInput.removeAttribute('name');
    nativeInput.replaceWith(appInput);
    if (label) label.setAttribute('for', appInput.id);

    appButton.className = nativeButton.className;
    appButton.setAttribute('role', 'button');
    nativeButton.replaceWith(appButton);

    if (appError) {
      appError.setAttribute('role', 'status');
      appError.classList.add('form__message');
      field.appendChild(appError);
    }

    nativeForm.addEventListener('submit', (event) => {
      event.preventDefault();
      if (typeof easylockdown === 'object' && typeof easylockdown.checkUnlockPassword === 'function') {
        easylockdown.checkUnlockPassword(appInput);
      }
    });

    nativeForm.replaceWith(appForm);
    appForm.replaceChildren();
    if (appNote) appForm.appendChild(appNote);
    appForm.appendChild(nativeForm);
    formAdapted = true;

    sync();
    return true;
  };

  const initialize = () => {
    layout = document.querySelector(LAYOUT_SELECTOR);
    if (!layout) return;

    layout.querySelector('.modal__close-button')?.addEventListener('click', () => {
      const modal = layout.querySelector('.password-modal');
      if (modal) modal.open = false;
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const modal = layout.querySelector('.password-modal');
      if (modal?.open) modal.open = false;
    });

    watchPasswordForm();

    const documentObserver = new MutationObserver(() => {
      const candidate = document.querySelector(FORM_SELECTOR);
      if (candidate && candidate !== appForm) {
        formAdapted = false;
        watchPasswordForm();
      } else if (appForm && !appForm.isConnected) {
        setActive(false);
        if (!formAdapted) appForm = null;
      }
    });
    documentObserver.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('easylockdown_loaded', () => {
    watchPasswordForm();
    window.setTimeout(sync, 0);
  }, { once: true });
})();
